import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export function TypingDots() {
    const [dots, setDots] = useState("");
    const [phase, setPhase] = useState<"typing" | "deleting">("typing");

    useEffect(() => {
        let i = 0;
        let interval: NodeJS.Timeout;

        const typing = () => {
            interval = setInterval(() => {
                if (phase === "typing") {
                    if (i < 3) {
                        i++;
                        setDots(".".repeat(i));
                    } else {
                        setPhase("deleting");
                    }
                } else {
                    if (i > 0) {
                        i--;
                        setDots(".".repeat(i));
                    } else {
                        setPhase("typing");
                    }
                }
            }, phase === "typing" ? 500 : 120);
        };

        typing();

        return () => clearInterval(interval);
    }, [phase]);


    return (
        <motion.div
            key="dots"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
        >
            <div className="p-3 pt-4 text-gray-500 border-t border-gray-100"
                style={{ fontSize: "28px" }}>
                {dots}
            </div>
        </motion.div>
    );
}
